import { plural3 } from '@tg/domain';

/* Даты — строками ISO «2026-10-05» в местном времени: дни тренировок — по дате, не по индексу. */

export const D = (s: string) => new Date(s + 'T00:00:00');
export const iso = (d: Date) =>
  d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
export const RU = ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];
export const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
export const MONTHS_N = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];
const WD_FULL = ['понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота', 'воскресенье'];

export const addDays = (s: string, n: number) => {
  const d = D(s);
  d.setDate(d.getDate() + n);
  return iso(d);
};
/** 0 — понедельник */
export const dowMon = (s: string) => (D(s).getDay() + 6) % 7;
export const monday = (s: string) => addDays(s, -dowMon(s));
export const localToday = () => iso(new Date());

export const dateLong = (s: string) => {
  const d = D(s);
  return WD_FULL[dowMon(s)] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
};
export const fullDate = (s: string) => {
  const d = D(s);
  return d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
};
export const shortDate = (s: string, today: string) => {
  const d = D(s);
  return d.getDate() + ' ' + MONTHS[d.getMonth()].slice(0, 3) + (d.getFullYear() !== D(today).getFullYear() ? ' ' + d.getFullYear() : '');
};
export const hhmm = (d: Date | string) => {
  const x = typeof d === 'string' ? new Date(d) : d;
  return String(x.getHours()).padStart(2, '0') + ':' + String(x.getMinutes()).padStart(2, '0');
};
export const age = (born: string | null | undefined, today: string) => {
  if (!born) return '';
  const b = D(born);
  const t = D(today);
  let a = t.getFullYear() - b.getFullYear();
  if (t.getMonth() < b.getMonth() || (t.getMonth() === b.getMonth() && t.getDate() < b.getDate())) a--;
  return a > 0 && a < 120 ? a + ' ' + plural3(a, 'год', 'года', 'лет') : '';
};
